<app-seriesheader class="notrans"></app-seriesheader>
<router-outlet>
</router-outlet>  
<app-loader></app-loader>
<app-new-videos></app-new-videos>
<app-disclaimer></app-disclaimer>
<app-messagemodal></app-messagemodal>
<app-videos-locked-popup></app-videos-locked-popup>
<app-subscription-update></app-subscription-update>
<app-submit-skill></app-submit-skill>
<app-footer></app-footer>